import {createRouter, createWebHistory} from 'vue-router'
import MainLayout from "@/layouts/MainLayout.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import {inject} from "vue";
import {requestHttp} from "@/services/HttpRequest";

const routes = [
    {
        path: '/',
        name: 'mainLayout',
        component: MainLayout,
        redirect: '/login',
        children: [
             {
                  path: '/login',
                  name: 'login',
                  meta: { public: true },
                  component: () => import( '../views/LoginView.vue')
             },
            {
                path: '/home',
                name: 'home',
                component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
            },
            {
                path: '/usertest',
                name: 'usertest',
                component: () => import(/* webpackChunkName: "about" */ '../views/Screen/UserTest.vue')
            },
            {
                path: '/player',
                name: 'player',
                component: () => import(/* webpackChunkName: "about" */ '../views/Screen/HomePlayer.vue')
            }
            /*,
            {
                path: '/prize',
                name: 'prize',
                component: () => import(/!* webpackChunkName: "about" *!/ '../views/PrizeView.vue')
            }*/,
            /*  {
                  path: '/password-change',
                  name: 'password-change',
                  component: () => import(/!* webpackChunkName: "about" *!/ '../views/NewPasswordView.vue')
              },*/
            /* {
                 path: '/forgot-password',
                 name: 'forgot-password',
                 meta: { public: true },
                 component: () => import(/!* webpackChunkName: "about" *!/ '../views/ForgotPasswordView.vue')
             },
             {
                 path: '/register-complete',
                 name: 'register-complete',
                 component: () => import(/!* webpackChunkName: "about" *!/ '../views/RegisterCompleteView.vue')
             },
            */
            /*    {
                    path: 'aceptar-terminos-condiciones',
                    name: 'aceptar-terminos-condiciones',
                    component: () => import(/!* webpackChunkName: "about" *!/ '../views/TerminosYcondicionesView.vue')
                },
                {
                    path: 'terminos-condiciones',
                    name: 'terminos-condiciones',
                    meta: { public: true },
                    component: () => import(/!* webpackChunkName: "about" *!/ '../views/UltimosTerminosYcondicionesView.vue')
                },*/

        ],

    },
    {path: '/:pathMatch(.*)*', name: 'notFount', component: NotFoundView},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    const rootScope = inject('rootScope')
    try {

        rootScope.loading = true;
        const response = await requestHttp({
            endpoint: "auth/authStatus",
        });

        rootScope.loading = false;
        const data = response.data;


        if (data.estado === 400) {
            rootScope.logged = false;
            rootScope.name = "";
            rootScope.user = 0;
            /*if ( to.name !== 'login' && to.name !== 'register' && to.name !== 'forgot-password') {
                next({name: 'login'});
            } else next();*/

            if (to.meta?.public) {
                next();
            } else {
                next({name: 'login'});
            }
        } else if (data.estado === 200) {
            const datosSession = data.data;
            rootScope.logged = datosSession.logueado;
            rootScope.name = datosSession.nombre;
            rootScope.user = datosSession.usuario;
            rootScope.registro_completo = datosSession.registro_completado;

            localStorage.setItem('usuario_id', datosSession.usuario)

            /*   if (to.name !== 'password-change' && datosSession.restablecer_clave === 0) {
                   next({name: 'password-change'});
               }*/

            if (to.name === 'login' || to.name === 'register') {
                next({name: 'player'});
            } else {
                next();
            }

        } else {
            rootScope.logged = false;
            localStorage.removeItem('token');
            next({name: 'login'});
        }

    } catch (error) {
        localStorage.removeItem('token');
        rootScope.logged = false;
        rootScope.loading = false;
        next({name: 'login'});
    }

});

export default router
